import { AddressMakeHc } from 'src/components/InternalTools/MakeHc';
import { AddressNotesRefactor } from 'src/components/InternalTools/NotesRefactor';
import { AddressProposeAttribution } from 'src/components/InternalTools/ProposeAttribution';
import { useAddressAndChainParams } from 'src/hooks/routing/useAddressAndChainParams';
import { RootModal } from './AddressRoot';

interface AddressToolbarProps {
  addressData?: {
    entity?: string;
  };
}

export const AddressToolbar = ({ addressData }: AddressToolbarProps) => {
  const { address } = useAddressAndChainParams();

  return (
    <div className="flex items-center gap-2">
      <AddressNotesRefactor address={address} />
      <AddressProposeAttribution address={address} />
      <AddressMakeHc
        address={address}
        currentAttribution={addressData?.entity}
      />
      <RootModal address={address} />
    </div>
  );
};
